export default function(value) {
  if (typeof value !== 'number') {
    return value;
  }
  if ('Intl' in window && 'NumberFormat' in window['Intl']) {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    });
    return formatter.format(value);
  }
}
